// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"d97c088f","11":"a88a5d4f","106":"71b3c52e","431":"5493665e","642":"7e99dcc1","804":"83a91572","915":"f5d89385","980":"d3b2a5ef"}[chunkId] + ".chunk.js";
};